import { dmApi } from "../../../app/dmApi";
import { serialize } from "../../../helpers/Utils";
import { getAuthorizationHeader, handleQueryError, handleQueryErrorAndSuccess } from "../../../helpers/RtkQueryUtils";

export const rolePermissionApi = dmApi.injectEndpoints({
    endpoints: (build) => ({
        
        getRolesWithPermissions: build.query({
            query: ({page}) => {
                return {
                    url: `/roles-with-permissions?page=${page}`,
                    method: 'GET',
                    headers: getAuthorizationHeader(),
                };
            },
            providesTags: ['rolesWithPermissions'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            },
        }),
        getPermissionsList: build.query({
            query: (id) => {
                return {
                    url: `/permissions-list`,
                    method: 'GET',
                    headers: getAuthorizationHeader(),
                };
            },
            providesTags: ['PermissionsList'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            },
        }),
        updateRolePermissions: build.mutation({
            query: ({ roleId, permissions }) => {
                return {
                    url: `/update-role-permission`,
                    method: 'POST',
                    headers: getAuthorizationHeader(),
                    body: {
                        role_id: roleId,
                        permissions: permissions
                    },
                };
            },
            invalidatesTags: ['rolesWithPermissions'],
            async onQueryStarted(_, { queryFulfilled }) {
                await handleQueryErrorAndSuccess(queryFulfilled , 'Permissions' ,'Updated')
            },
        }),

        createRole: build.mutation({
            query: (requestBody) => ({
                url: `/create-role`,
                method: 'POST',
                headers: getAuthorizationHeader(),
                body: requestBody,
            }),
            invalidatesTags: ['rolesWithPermissions'],
            async onQueryStarted(_, { queryFulfilled }) {
                await handleQueryErrorAndSuccess(queryFulfilled, 'Created', 'Role');
            },
        }),

        getWorkingAreas: build.query({
            query: () => ({
                url: `/working-areas`,
                method: 'GET',
                headers: getAuthorizationHeader(),
            }),
            providesTags: ['workingAreas'],
            async onQueryStarted(_, { queryFulfilled }) {
                await handleQueryError(queryFulfilled);
            },
        }),
        
    }),
});


export const {
    useGetRolesWithPermissionsQuery,
    useGetPermissionsListQuery,
    useUpdateRolePermissionsMutation,
    useCreateRoleMutation,
    useGetWorkingAreasQuery,
} = rolePermissionApi;